import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Modal, Text, DatePicker, Theme, i18n, tokens, localizationMaps, Services, TextInput } from '@simplybenefits/sb-ui-library';
import moment from 'moment';

class FilterClaims extends PureComponent {
    state = {
        dateRange: {
            startDate: moment().startOf('year'),
            endDate: moment(),
            error: null
        },
        isDatePickerOpen: false,
        errorText: null,
        category: i18n.t(tokens.labels.claims.allCategories),
        service: i18n.t(tokens.labels.claims.allServiceTypes),
        serviceOptions: [ i18n.t(tokens.labels.claims.allServiceTypes) ]
    };

    /**
     * Used in the datepicker to set local state
     * @param startDate
     * @param endDate
     */
    _submitDate = (dateRange) => {
        this.setState({
            dateRange
        });

        if (!dateRange.error) {
            this.setState({
                errorText: null
            });
        }
    };
    
    // eslint-disable-next-line consistent-return
    _onSave = async () => {
        
        if (this.state.dateRange.error) {

            await this.setState({
                errorText: i18n.t(tokens.labels.claims.pleaseProvideValidDateRange)
            });

            return null;
        }

        const dateRange = {
            startDate: this.state.dateRange.startDate,
            endDate: this.state.dateRange.endDate
        };

        this.props.onSave(dateRange, localizationMaps.toEnglish("categories", this.state.category), localizationMaps.toEnglish("benefits", this.state.service));
    };

    _setIsDatePickerOpen = async (toggleValue) => {
        if (toggleValue === null) {
            await this.setState({
                isDatePickerOpen: false
            });
        }

        if (toggleValue !== null) {
            await this.setState({
                isDatePickerOpen: true
            });
        }
    };

    _changeClaimType = async (type, event) => {
        await this.setState({
            [type]: event.target.value
        });

        if (type === 'category') {
            this._setServiceOptions(localizationMaps.toEnglish("categories", event.target.value));
        }
    };

    _setServiceOptions = (category) => {
        let options = [ 'All Service Types' ];

        if (category !== 'All Categories') {
            options = [ 'All Service Types', ...this.props.claimTypes[category].reverse() ];
        }

        this.setState({
            serviceOptions: options,
            service: localizationMaps.fromEnglish("benefits", options[0])
        });
    };

    render() {
        const styles = {
            containerStyle: {
                minWidth: 500,
                height: this.state.isDatePickerOpen ? "615px" : "auto",
                flex: "none",
                display: 'flex',
                flexDirection: 'column',
                padding: '40px 0'
            },
            formStyle: {
                height: '100%',
                maxHeight: '100%',
                padding: '5px 40px'
            },
            titleIconWrapperStyle: {
                padding: '0 40px'
            },
            body: {
                flex: 1,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: Theme.colors.surface
            }
        };

        const categoryOptions = [ ...Services.selectFieldOptions.categoryOptions(), i18n.t(tokens.labels.claims.allCategories) ];
        
        return (
            <Modal
                testid="filter-claims-modal"
                open={ true }
                onClose={ this.props.close }
                aria-labelledby="Claims Summary"
                title={ i18n.t(tokens.titles["claims summary"]) }
                customContainerStyle={ styles.containerStyle }
                customFormStyle={ styles.formStyle }
                customTitleIconWrapperStyle={ styles.titleIconWrapperStyle }
                primaryButton={{
                    label: i18n.t(tokens.buttons.getClaimsSummary),
                    onClick: this._onSave
                }}
            >
                <div style={ styles.body }>
                    <Text medium margin="10px 0 0 0">
                        { i18n.t(tokens.labels.claims.category) }
                    </Text>

                    <TextInput
                        label={ i18n.t(tokens.labels.claims.selectCategory) }
                        variant="outlined"
                        value={ this.state.category }
                        onChange={(event) => this._changeClaimType('category', event)}
                        select
                        required
                        fullWidth
                        selectOptions={ categoryOptions }
                    />

                    <Text medium margin="10px 0 0 0">
                        { i18n.t(tokens.labels.claims.serviceType) }
                    </Text>

                    <TextInput
                        label={ i18n.t(tokens.labels.claims.selectService) }
                        variant="outlined"
                        value={ this.state.service }
                        onChange={ (event) => this._changeClaimType('service', event) }
                        select
                        required
                        fullWidth
                        selectOptions={ this.state.serviceOptions.map((option) => localizationMaps.fromEnglish("benefits", option))}
                    />

                    <Text medium margin="15px 0 15px 0">
                        { i18n.t(tokens.labels.claims.dateRange) }
                    </Text>
                    
                    <DatePicker
                        startDate={ this.state.startDate }
                        endDate={ this.state.endDate }
                        submitDate={ this._submitDate }
                        isPickerOpen={this._setIsDatePickerOpen}
                        defaultSelectedValue={ "This Year" }
                    />

                    { 
                        this.state.errorText ? 

                            <Text medium color={"red"}>
                                { this.state.errorText }
                            </Text>
                            :
                            null
                    }
                </div>

                <span id="filterclaimsform" />
            </Modal>
        );
    }
}

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    claimTypes: state.usage.data.claimTypes
});

export default connect(mapStateToProps)(FilterClaims);